import { useState, useMemo, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const useTaskFilter = (tasks, user, userId = null) => {
  const params = useParams();
  const convertStringArrayToIntegerArray = (strArr) => strArr.map(Number);

  const [searchKey, setSearchKey] = useState('');

  const [order, setOrder] = useState(() => {
    const savedOrder = localStorage.getItem('taskOrder');
    return savedOrder !== null ? parseInt(savedOrder) : 0;
  });

  useEffect(() => {
    localStorage.setItem('taskOrder', order.toString());
  }, [order]);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  
const [isDoneFilter, setIsDoneFilter] = useState(() => {
  const param = new URLSearchParams(window.location.search).get("is-completed");
  if (param === "false") return true;   // ha azt mondja: completed=false → rejtse el a kész feladatokat
  if (param === "true") return false;   // completed=true → mutassa mindet
  return false;                         
});

  const canViewCompletedTask = user?.permissions?.includes("pwaViewCompletedTasks");

  const filteredTasks = useMemo(() => {

    let filtered = tasks
      .filter(task => {
        const matchesUser = userId === null || task.sub_tasks.some(subtask => subtask.user_id === userId);
        const matchesSearch = task.name.toLowerCase().includes(searchKey.toLowerCase());
        return matchesUser && matchesSearch;
      });

    // Csak akkor szűrjük táblák szerint, ha tableId létezik és szám
    if (params.tableId && !isNaN(Number(params.tableId))) {
      filtered = filtered.filter(element =>
        convertStringArrayToIntegerArray(element.table_id).includes(Number(params.tableId))
      );
    }

    if (!canViewCompletedTask) {
      filtered = filtered.filter(task => !task.completed_at);
    } else if (isDoneFilter) {
      filtered = filtered.filter(task => !task.completed_at);
    }



    filtered = filtered.sort((a, b) => {
      if (order === 1) {
        return new Date(a.started_at) - new Date(b.started_at);
      } else {
        return new Date(b.started_at) - new Date(a.started_at);
      }
    });

    return filtered;
  }, [tasks, userId, searchKey, isDoneFilter, order, user]);

  return {
    searchKey,
    setSearchKey,
    isDoneFilter,
    setIsDoneFilter,
    order,
    setOrder,
    filteredTasks,
  };
};

export default useTaskFilter;
